<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="14" y1="1.76777" x2="1.62563" y2="14.1421" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
</svg>
